module.exports = __webpack_public_path__ + "static/img/gsjj.8b38ffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/gsjj.jpg
// module id = IPB9
// module chunks = 15